<style lang="less" scoped>
    @import "./../assets/less/base.less";
    .mainF{
        width: 6.4rem;height:100%;background: #F6F6F6; margin: 0 auto;position: relative;
        padding: ~'constant(safe-area-inset-top) constant(safe-area-inset-right) constant(safe-area-inset-bottom) constant(safe-area-inset-left)';
    }
    .headerF {
        width: 100%;position: absolute;top:-1.53rem;
    }
    .swiper-slide{
        width: 6.4rem;height: 2.78rem;
    }
    .bottomF{
        background-color: white;
        height: 100%;
        margin-top: 1.9rem;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center;
        padding-top: 1.27rem;
    }
    .vipItem{
        width: 5.88rem;
        height: 1.27rem;
        border-radius: 0.1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top:0.17rem;
        background: #FFFFFF;
        border: 0.04rem solid #ffffff;
    }
    .leftT{
        display: flex;
        flex-direction: row;
        align-items: baseline;
        color: #282828;
        font-size: 0.43rem;
        font-weight: 500;
        margin-left: 0.18rem;
    }
    .oldPrice{
        font-size: 0.22rem;
        font-weight: 400;
        margin-left: 0.18rem;
        color: #909497;
        text-decoration: line-through;
    }
    .hint{
        color: #909497;
        font-size: 0.26rem;
        margin-left: 0.18rem;
        margin-top: 0.1rem;
    }
    .btnVip{
        width: 1.71rem;
        height: 0.64rem;
        border: 0.03rem solid #F8B534;
        color:#F8B534;
        border-radius: 0.32rem;
        font-size: 0.26rem;
        text-align: center;
        line-height: 0.65rem;
        margin-right: 0.18rem;
    }
    .choose{
        border: 0.04rem solid #47C878;
        background: #F4FFF8;
    }
    .chooseItem{
        background-color: #F8B534;
        color: #FFFFFF;
    }
    .buyBtn{
        margin-top:0.27rem;
        width: 5.72rem;
        line-height: 0.85rem;
        background: #47C878;
        border-radius: 0.43rem;
        font-size: 0.31rem;
        text-align: center;
        color: #fff;
        position: relative;
    }
    .rightIcon{
        position: absolute;
        right: 0.62rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        margin-top: -0.85rem;
        width: 0.3rem;
        line-height: 0.85rem;
    }
    .swing{
        position: absolute;
        animation:move 3s 0s infinite;
        -webkit-animation:move 3s 0s ease-in-out;
        animation-delay: 0.5s;
        animation-iteration-count: infinite;
        width: 0.3rem;
        height: 0.2rem;
    }

    @keyframes move {
        0%{
            right: 0.52rem;
        }
        70% {
            right: 0.32rem;
        }
        100% {
            right: 0.25rem;
        }
    }
    .hintText{
        margin: 0.18rem 0.38rem 0.1rem;
        color: #C0C3C5;
        font-size: 0.17rem;
    }
    .handle{
        width: 90%;
        margin: 0.3rem 1rem 0.14rem;
        color: #C0C3C5;
        font-size: 0.17rem;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
    }
    .handleItem{
        text-decoration: underline;
    }

    /*黑色半圆是图片，上下箭头也是图片*/
         .footer_btn{text-align:center;line-height:0.22rem;width: 0.3rem}
         @keyframes bounce-down {
          25% {transform: translateX(-5px);}
          50%{transform: translateX(0);}
          75% {transform: translateX(5px);}
          100% {transform: translateX(0);}
         }
         .animate-bounce-down{ -webkit-animation: bounce-down 1s linear infinite;animation: bounce-down 1s linear infinite;
       }

    .tips {
        color: #FFF; font-size: 24px;  position: fixed; top: 50%; left: -0px; z-index: 100; text-align: center; width: 100%;
        .t_c {
            padding: 0.2rem 0.8rem; border-radius: 0.1rem; background: rgba(0, 0, 0, 0.8); display: inline-block;
        }
    }
    .swiT{
        width: 100%;
        font-size: 0.27rem;
        color: #282828;
        text-align: center;
        position: absolute;
        bottom: 0.45rem;
    }
    .swiper-container{width:100%;height:100%;margin:0 auto;position:relative;}
    .swiper-container img{display:block;width:5.46rem;height:2.78rem;margin:0 auto;}
    .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {bottom:0;left:0;width:100%;}
    .swiper-pagination-bullet-active {background-color:#ffd200;}
</style>

<template>
    <section class="mainF" ref="game">
        <section class="tips" v-if="toastT">
            <div class="t_c">{{toastT}}</div>
        </section>
        <div class="headerF">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item,index) in swiperInfo" :key="index">
                        <img :src="require('../assets/images/show'+index+'.png')" class="swiperImg"/>
                        <div class="swiT">{{item}}</div>
                    </div>
                </div>
            </div>
        </div>
        <section class="bottomF">
            <div v-for="(item, index) in vipInfo" :key="index">
                <div :class="[chooseIdx==index?'choose':'','vipItem']" @click="chooseItem(index)">
                    <div>
                        <div class="leftT">
                            {{item.nowPrice}}
                            <span class="oldPrice">{{item.oldPrice}}</span>
                        </div>
                        <div class="hint">{{item.hint}}</div>
                    </div>
                    <div :class="[chooseIdx==index?'chooseItem':'','btnVip']">{{item.avePrice}}</div>
                </div>
            </div>
            <div class="buyBtn" @click="buyVip">立即解锁
            <div class="rightIcon">
                <img src="../assets/images/rightIcon.png" class="animate-bounce-down">
            </div>
            </div>
            <div class="handle">
                <div class="handleItem" v-for="(item,index) in handleInfo" :key="index" @click="handle(index)">{{item}}</div>
            </div>
        </section>
    </section>
</template>

<script type="text/ecmascript-6">
    import showToast from './showToast.vue'
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.min.css';
    import constants from '../assets/js/const';

    export default {
        data() {
            return {
                urlParma:{},//链接参数
                toastT:'',//提示消息
                swiperInfo:['查看好友实时位置','到达/离开动态通知','30天历史轨迹','一键求助好友'],
                vipInfo:[
                    {oldPrice:'¥149',nowPrice:'¥88',avePrice:'仅2.9元/天',hint:'月度服务'},
                    {oldPrice:'¥189',nowPrice:'¥108',avePrice:'仅1.2元/天',hint:'季度服务'},
                    {oldPrice:'¥229',nowPrice:'¥128',avePrice:'仅0.7元/天',hint:'半年服务'},
                    {oldPrice:'¥319',nowPrice:'¥198',avePrice:'仅0.5元/天',hint:'全年服务'}
                    ],
                chooseIdx:-1,
                handleInfo:['使用条款','隐私协议'],//操作详情
            }
        },
        created() {
            this.getParma();
            //注册界面分辨率
            this.$Base.loadInit(6.4);
        },
        computed: {
            test() {
                return '' //this.$store.state.test;
            },
            state() { //游戏状态
                return this.$store.state.gameData.state;
            },
        },
        mounted() {
            window.backWebUrl = this.backWebUrl;
            window.showCheckResult = this.showCheckResult;
            window.buyResult = this.buyResult;
            var mySwiper2 = new Swiper('.swiper-container', {
                autoplayDisableOnInteraction : false,
                autoplay:2000,//自动滑动
                speed:500,//自动滑动开始到结束的时间（单位ms）
                loop:true,//开启循环
                loopedSlides:3,//在loop模式下使用slidesPerview:'auto',还需使用该参数设置所要用到的loop个数。
                slidesPerView:'auto',//设置slider容器能够同时显示的slides数量(carousel模式)。另外，支持'auto'值，会根据容器container的宽度调整slides数目。
                effect:'coverflow',//可以实现3D效果的轮播,
                centeredSlides:true,//设定为true时，active slide会居中，而不是默认状态下的居左。
                coverflow:{
                    rotate:0,//slide做3d旋转时Y轴的旋转角度。默认50。
                    stretch:20,//每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
                    depth:150,//slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
                    modifier:1,//depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
                    slideShadows:false,//开启slide阴影。默认 true。
                },
            });
        },
        methods: {
             getStatus(){//查询状态
                 if (!window.webkit){
                     return
                 }
                 window.webkit.messageHandlers.checkUserInfo.postMessage({});

             },
            buyResult(value){
                 if(value=="1"){
                     this.toastFun('支付成功')
                     if (!window.webkit){
                         return
                     }
                     window.webkit.messageHandlers.closeWebVC.postMessage({});
                 }else{
                     this.toastFun('支付失败')
                 }
            },
             backWebUrl(value){
                window.location.href=value
            },
            getParma(){
                var parma=window.location.href.split('?')[1];
                parma=decodeURIComponent(parma);
                var paList=parma.split('&');
                this.urlParma={};
                for(var item of paList){
                    var i=item.split('=');
                    if(i[0]=='dataList'){
                        this.urlParma[i[0]]=JSON.parse(i[1])
                    }else{
                        this.urlParma[i[0]]=i[1]
                    }
                }
                this.vipInfo=this.urlParma.dataList
                if(this.vipInfo.length>-1){
                    this.chooseIdx=0
                }
                if(this.urlParma['isBack']=='1'){
                    this.$emit('payOk')
                }
            },
            handle(index){
                if (!window.webkit){
                    return
                }
                var hanleList=['userAgreement','privacyPolicy','restore']
                window.webkit.messageHandlers[hanleList[index]].postMessage(index==2?{sourceType:this.urlParma.sourceType}:{});
            },
            chooseItem(index){
                this.chooseIdx=index
            },
            buyVip(){
                if (!window.webkit||this.chooseIdx==-1){
                    return;
                }
                if(this.urlParma['installedWechat']=='true'){//微信
                    window.webkit.messageHandlers.makeOrder.postMessage({productId:this.urlParma.dataList[this.chooseIdx].productId,sourceType:this.urlParma.sourceType});
                }else{//苹果
                    window.webkit.messageHandlers.originalPay.postMessage({productId:'',sourceType:this.urlParma.sourceType});
                }
            },
            toastFun(str){
                this.toastT=str
                var that=this
                var timer=setTimeout(function () {
                    that.toastT=''
                    clearTimeout(timer)
                },1500)
            }
        },
    };
</script>
